import { Ticket, TicketType } from '../../types/ticket';
import { Rule } from '../Rule';
import { RuleContext } from '../RuleContext';

export class SortTicketsByDateAndClosingAndStockRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { tickets } = context;
    return tickets.sort((currentTicket, nextTicket) => {
      const currentEarliestBeginSales = this.getEarliestBeginSalesDate(currentTicket.type);
      const nextEarliestBeginSales = this.getEarliestBeginSalesDate(nextTicket.type);

      const currentSoldOut = this.checksIfAllTicketsAreSoldOut({ ticket : currentTicket });
      const nextSoldOut = this.checksIfAllTicketsAreSoldOut({ ticket : nextTicket });

      const currentHasSellableType = this.hasSellableTicketType(currentTicket);
      const nextHasSellableType = this.hasSellableTicketType(nextTicket);

      // Prioritize tickets that can be sold
      if (currentHasSellableType && !nextHasSellableType) return -1;
      if (!currentHasSellableType && nextHasSellableType) return 1;

      // Prioritize tickets that are not sold out
      if (currentSoldOut && !nextSoldOut) return 1;
      if (!currentSoldOut && nextSoldOut) return -1;

      // Prioritize by earliest begin sales date
      if (currentEarliestBeginSales > nextEarliestBeginSales) return 1;
      if (currentEarliestBeginSales < nextEarliestBeginSales) return -1;

      return 0; // Keep original order if all conditions are equal
    });
  }

  private getEarliestBeginSalesDate(types: TicketType[]) {
    return types.reduce((earliest, current) => {
      const currentBeginSalesDate = new Date(current.beginSales);
      return currentBeginSalesDate < earliest ? currentBeginSalesDate : earliest;
    }, new Date(Infinity));
  }

  private checksIfAllTicketsAreSoldOut({ ticket }: { ticket: Ticket }) {
    return ticket.type.every(({ quantityInStock }) => quantityInStock === 0);
  }

  private hasSellableTicketType(ticket: Ticket) {
    return ticket.type.some(({ quantityInStock }) => quantityInStock > 0);
  }
}
